/**
 * InstallBridgeScreen — Explains why to install the PWA.
 *
 * UI-INV-005: Leaf component, props only.
 * Shown after PermissionsScreen if app is not installed (not in standalone mode).
 */
import styles from "./InstallBridgeScreen.module.css";
import { TEST_IDS } from "../testing/testIds";
import { PrimaryAction } from "../primitives/PrimaryAction";
import { SecondaryAction } from "../primitives/SecondaryAction";

type Props = {
  onInstall: () => void;
  onSkip: () => void;
};

export function InstallBridgeScreen({ onInstall, onSkip }: Props) {
  return (
    <div className={styles.screen} data-testid={TEST_IDS.INSTALL_BRIDGE_SCREEN}>
      <div className={styles.meta}>
        <span className={styles.metaLabel}>One more thing</span>
      </div>

      <div className={styles.content}>
        <h1 className={styles.heading}>Install for the full experience.</h1>
        <p className={styles.intro}>
          The browser version rings bells — but only while the screen stays on.
          The installed app rings bells even when your phone sleeps.
        </p>

        <div className={styles.list}>
          <div className={styles.rule} />
          <div className={styles.item}>
            <div className={styles.glyph}>◯</div>
            <div>
              <div className={styles.itemTitle}>Bells while locked</div>
              <div className={styles.itemBody}>
                installed app only — essential for overnight sits
              </div>
            </div>
          </div>
          <div className={styles.rule} />
          <div className={styles.item}>
            <div className={styles.glyph}>△</div>
            <div>
              <div className={styles.itemTitle}>Works offline</div>
              <div className={styles.itemBody}>
                no internet required mid-retreat
              </div>
            </div>
          </div>
          <div className={styles.rule} />
        </div>

        <div className={styles.ctas}>
          <PrimaryAction onClick={onInstall} testId={TEST_IDS.INSTALL_BRIDGE_INSTALL_BTN}>Install to home screen</PrimaryAction>
          <SecondaryAction onClick={onSkip} testId={TEST_IDS.INSTALL_BRIDGE_SKIP_BTN}>Skip for now</SecondaryAction>
        </div>
      </div>
    </div>
  );
}
